import React from 'react';
import { Dropdown } from 'react-bootstrap';
import classnames from 'classnames';
import FlairDateRange from '../../../../../../atomic/molecules/DateRange/FlairDateRange';
import { FlairDateFormat } from '../../../../../../atomic/atoms/FlairFormattedDate/types';
import './GoalPeriodSelector.css';

export type PeriodDropdownItem = {
  Id: string;
  Name: string;
  flair__Start_Date__c: string;
  flair__End_Date__c: string;
};

type Props = {
  periods: readonly PeriodDropdownItem[];
  currentPeriod: PeriodDropdownItem | null;
  onSelect: (periodId: string | null) => void;
  selectLabel: string;
};

export const PeriodDropdown: React.FC<Props> = ({
  periods,
  currentPeriod,
  onSelect,
  selectLabel,
}) => {
  if (periods.length === 1) {
    return (
      <div>
        <PeriodDateRange period={periods[0]} />
        <h1 className="header-title fs-2 fw-bold text-black">
          {periods[0].Name}
        </h1>
      </div>
    );
  }

  return (
    <div>
      {currentPeriod && <PeriodDateRange period={currentPeriod} />}
      <Dropdown
        onSelect={(value: string | null) => onSelect(value)}
        className="goal-period-selector">
        <Dropdown.Toggle
          variant="link"
          className={classnames('p-0', 'fs-2', 'fw-bold', 'text-black')}>
          {currentPeriod?.Name ?? selectLabel}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {periods.map((period) => (
            <Dropdown.Item
              key={period.Id}
              eventKey={period.Id}
              active={period.Id === currentPeriod?.Id}>
              <div
                className={classnames({
                  active: period.Id === currentPeriod?.Id,
                })}>
                <div>
                  <PeriodDateRange period={period} />
                </div>
                <div>{period.Name}</div>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export const PeriodDateRange: React.FC<{
  period: PeriodDropdownItem;
}> = ({ period }) => {
  return (
    <div className="text-uppercase fs-5 text-muted">
      <FlairDateRange
        format={FlairDateFormat.DayMonthLongYearFull}
        dateFrom={period.flair__Start_Date__c}
        dateTo={period.flair__End_Date__c}
      />
    </div>
  );
};
